import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated, isGuest } from '../data/store/api';

const ProtectedRoutes = () => {
  const location = useLocation();
  return isAuthenticated() || isGuest() ? (
    <Outlet />
  ) : (
    <Navigate
      to={`${location.state.backgroundLocation.pathname}${location.state.backgroundLocation.search}`}
    />
  );
};

export default ProtectedRoutes;
